import { Inject, Injectable } from '@angular/core';
import { CommandHandlerFor, Http } from '@skylab-angular-shared/core';
import { AdjustmentReasonSetDefaultCommand, AdjustmentReasonSetDefaultCommandHandlerBase, AdjustmentReasonSetDefaultResponse } from '@skylab-shared/business';
import { HttpService } from '@skylab-shared/core';

@CommandHandlerFor(AdjustmentReasonSetDefaultCommand)
@Injectable({ providedIn: 'root'})
export class AdjustmentReasonSetDefaultCommandHandler {
    private commandHandler: AdjustmentReasonSetDefaultCommandHandlerBase;
    public constructor(
        @Inject(Http) http: HttpService
    ) {
        this.commandHandler = new AdjustmentReasonSetDefaultCommandHandlerBase(http);
    }

    public async handleAsync(cmd: AdjustmentReasonSetDefaultCommand): Promise<AdjustmentReasonSetDefaultResponse> {
        return await this.commandHandler.handleAsync(cmd);
    }
}
